export default "__VITE_ASSET__3pTgJApz__"